import { useGetSubscriptionInvoices } from '@/shared/api/generated/subscriptions';

export const useBillingHistory = () => useGetSubscriptionInvoices();
